import { SHStack } from "@components/design-systems";
import { RootState } from "@redux/store";
import { useSelector } from "react-redux";
import { BusinessMetricCategoriesConfigs } from "../../configs";
import { AnalysisBusinessMetricCategory } from "../category";

export const AnalysisBusinessMetricCategoriesContainer = () => {
  const storedCategories = useSelector(
    (state: RootState) => state.platformAnalysis?.businessMetricSelections,
  );

  if (!storedCategories) return <></>;
  return (
    <SHStack gap={"20px"} marginTop={"20px"}>
      {BusinessMetricCategoriesConfigs.map((categoryConfig) => {
        const { key, title, icon, getCategoryData } = categoryConfig;
        const categoryData = getCategoryData(storedCategories) || [];

        return (
          <AnalysisBusinessMetricCategory
            key={key}
            title={title}
            titleIcon={icon}
            categoryData={categoryData}
            categoryKey={key}
          />
        );
      })}
    </SHStack>
  );
};
